if (!customElements.get("service-area-checker")) {
  customElements.define(
    "service-area-checker",
    class ServiceAreaChecker extends HTMLElement {
      connectedCallback() {
        this.pills = Array.from(this.querySelectorAll(".lssa__pill"));
        this.card = this.querySelector(".lssa__result-card");
        this.servedTown = this.querySelector(".lssa__result-town");
        this.servedCtaText = this.querySelector(".lssa__result-cta-text");
        this.confirmTown = this.querySelector(".lssa__confirm-town");
        this.fencesRow = this.querySelector(
          '.lssa__result-row[data-service="fences"]'
        );

        const dataEl = this.querySelector(".lssa__checker-data");
        this.config = dataEl ? JSON.parse(dataEl.textContent) : {};

        if (!this.card || this.pills.length === 0) return;

        this.onPillClick = this.onPillClick.bind(this);
        this.onSearchInput = this.onSearchInput.bind(this);
        this.pills.forEach((pill) =>
          pill.addEventListener("click", this.onPillClick)
        );

        this.input = this.querySelector(".lssa__checker-input");
        if (this.input) this.input.addEventListener("input", this.onSearchInput);

        const defaultPill =
          this.pills.find((p) => p.dataset.link) ||
          this.pills.find((p) => p.dataset.coverage === "full") ||
          this.pills[0];
        this.defaultPill = defaultPill;
        if (defaultPill) this.selectPill(defaultPill);
      }

      disconnectedCallback() {
        this.pills.forEach((pill) =>
          pill.removeEventListener("click", this.onPillClick)
        );
        if (this.input) this.input.removeEventListener("input", this.onSearchInput);
      }

      onPillClick(e) {
        this.selectPill(e.currentTarget);
      }

      matchesQuery(pill, query) {
        const name = (pill.dataset.town || "").toLowerCase();
        if (name.includes(query)) return true;
        const zips = (pill.dataset.zips || "").split(",");
        return zips.some((zip) => {
          const clean = zip.trim();
          return clean !== "" && clean.startsWith(query);
        });
      }

      onSearchInput() {
        const query = this.input.value.trim().toLowerCase();

        if (query === "") {
          this.pills.forEach((pill) => (pill.hidden = false));
          if (this.defaultPill) this.selectPill(this.defaultPill);
          return;
        }

        const matches = this.pills.filter((pill) => this.matchesQuery(pill, query));
        this.pills.forEach((pill) => (pill.hidden = !matches.includes(pill)));

        if (matches.length > 0) {
          this.selectPill(matches[0]);
        } else {
          this.pills.forEach((pill) => pill.classList.remove("is-selected"));
          this.card.dataset.state = "confirm";
          if (this.confirmTown) this.confirmTown.textContent = this.input.value.trim();
        }
      }

      setFenceAvailability(available) {
        if (!this.fencesRow) return;
        const badge = this.fencesRow.querySelector(".lssa__result-badge");
        const iconBg = this.fencesRow.querySelector(".lssa__result-icon-bg");
        const availLabel = this.config.badgeAvailable || "Available";
        const unavailLabel = this.config.badgeUnavailable || "Not Available Yet";
        if (badge) {
          badge.textContent = available ? availLabel : unavailLabel;
          badge.classList.toggle("lssa__result-badge--available", available);
        }
        if (iconBg) {
          iconBg.classList.toggle("lssa__result-icon-bg--available", available);
        }
      }

      selectPill(pill) {
        this.pills.forEach((p) => p.classList.remove("is-selected"));
        pill.classList.add("is-selected");

        const town = pill.dataset.town || "";
        const coverage = pill.dataset.coverage || "partial";
        // A pill is always a known town with known coverage (full or partial) —
        // `link` is only an optional blog article, not a signal of whether we
        // serve the area, so the breakdown is always the accurate "served" state.
        const link = pill.dataset.link || "";

        this.card.dataset.state = "served";
        this.card.dataset.coverage = coverage;
        if (this.servedTown) {
          this.servedTown.textContent = town;
          if (link) {
            this.servedTown.setAttribute("href", link);
          } else {
            this.servedTown.removeAttribute("href");
          }
        }
        if (this.servedCtaText) {
          const prefix = this.config.boxButtonPrefix || "Get a Free Quote in";
          this.servedCtaText.textContent = prefix + " " + town;
        }
        this.setFenceAvailability(coverage === "full");
      }
    }
  );
}
